import { createSlice } from '@reduxjs/toolkit';
import i18next from 'i18next';

const initialState = {
    language: sessionStorage.getItem("language") || 'es'
};

export const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        set: (state, action) => {
            state.language = action.payload;
            i18next.changeLanguage(state.language);
            sessionStorage.setItem("language", state.language);
        }
    }
});

export const { set } = languageSlice.actions;
